exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-math-strapi-addsub-document-id-js": () => import("./../../../src/pages/math/{strapiAddsub.documentId}.js" /* webpackChunkName: "component---src-pages-math-strapi-addsub-document-id-js" */)
}

